export type WithListOrder = { list_order: number };

export function sortByListOrder<T extends WithListOrder>(items: T[]): T[] {
    return items.slice().sort((a, b) => a.list_order - b.list_order);
}

export function renumber<T extends WithListOrder>(items: T[]): T[] {
    return sortByListOrder(items).map((item, index) => ({
        ...item,
        list_order: index + 1,
    }));
}

export function setItemOrder<T extends WithListOrder>(
    items: T[],
    id: number | string,
    newOrder: number,
    getId: (item: T) => number | string
): T[] {
    const sorted = sortByListOrder(items);
    const index = sorted.findIndex((item) => getId(item) === id);
    if (index < 0) return items;

    const clamped = Math.max(1, Math.min(Math.round(newOrder) || 1, sorted.length));
    const [item] = sorted.splice(index, 1);
    sorted.splice(clamped - 1, 0, item);
    // Assign from array position — do not call renumber() (it re-sorts by stale list_order).
    return sorted.map((entry, i) => ({
        ...entry,
        list_order: i + 1,
    }));
}
